import { isBlank } from '../../utils/isBlank'

export const skipClosestYard = (ctx, event) => {
  return !isBlank(event?.data?.yardFromUrl)
}
